import { render, staticRenderFns } from "./card-complete.vue?vue&type=template&id=2f0bffb0&"
import script from "./card-complete.vue?vue&type=script&lang=js&"
export * from "./card-complete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports